export function getPathFromUrl(url?: string | null | undefined): string {
  if (!url) {
    return ''
  }
  return url.replace(/^https?:\/\/[^/]+/, '')
}
